export const M6_UNIT_15 = {
  id: "m6-u15-contact-details",
  title: "Unidad 15: Contact Information & Personal Details",
  topic: "Master how to give and understand contact information! Essential for making friends, job applications, emergencies, and networking anywhere in the world! 📞✉️",
  iconType: "address-card",
  grammarImage: "grammar/grammar-m6-u15.jpg",
  grammarText: "Learn to spell names, say phone numbers with 'double' and 'triple', pronounce email addresses with 'at' and 'dot', and understand US vs UK differences!",
  
  sets: [
    // ============================================
    // SETS 1-2: PERSONAL INFORMATION VOCABULARY
    // ============================================
    {
      id: "m6-u15-s1",
      title: "Set 1: Names & Titles",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "What do you call your complete name? First name + last name = ___",
          options: ["Full name", "Big name", "Complete name"],
          a: "Full name",
          tip: "FULL NAME = nombre completo! First + middle + last!",
          successtip: "✓ FULL NAME! First name (given name) + Last name (surname/family name)! Universal pattern!"
        },
        {
          type: "mc",
          q: "Mr., Mrs., Ms., Dr. are examples of ___.",
          options: ["Titles", "Names", "Jobs"],
          a: "Titles",
          tip: "TITLES come before names! Show respect and marital status!",
          successtip: "✓ TITLES! Mr. (man), Mrs. (married woman), Ms. (any woman), Dr. (doctor)! Professional worldwide!"
        },
        {
          type: "order",
          q: "Traduce: Mi nombre es Juan Carlos López.",
          words: ["My", "name", "is", "Juan", "Carlos", "López"],
          a: "My name is Juan Carlos López",
          tip: "MY NAME IS! First name + middle name + last name!",
          successtip: "✓ FULL NAME! Juan = first name, Carlos = middle name, López = last name! Complete!"
        },
        {
          type: "input",
          q: "Complete: First name = given name. Last name = ___ or family name.",
          a: ["surname", "Surname"],
          tip: "SURNAME = apellido! Same as last name or family name!",
          successtip: "✓ SURNAME! Three terms same meaning: surname, last name, family name! All correct!"
        },
        {
          type: "match",
          q: "Match the title to who uses it:",
          pairs: [
            { left: "Mr.", right: "Any man" },
            { left: "Ms.", right: "Any woman" },
            { left: "Dr.", right: "Doctor" }
          ],
          a: "completed",
          successtip: "✓ TITLES! Ms. modern, doesn't show marital status! Professional standard worldwide!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My name is the Juan. ¿Correcto?",
          options: ["Yes, correct", "No, My name is Juan", "Both work"],
          a: "No, My name is Juan",
          tip: "No THE before names! My name IS Juan!",
          successtip: "✓ NO THE! Never use article THE before personal names in English!"
        },
        {
          type: "input",
          q: "Complete: What's your ___ name? (primer nombre)",
          a: ["first", "First"],
          tip: "FIRST NAME = given name = nombre de pila!",
          successtip: "✓ FIRST NAME! The name your parents gave you! Universal question!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cuál es tu apellido?",
          words: ["What's", "your", "last", "name"],
          a: "What's your last name",
          tip: "WHAT'S YOUR = What is your! Last name = apellido!",
          successtip: "✓ LAST NAME! Essential question for forms, introductions, registrations worldwide!"
        },
        {
          type: "mc",
          q: "Some people have a ___ name between first and last.",
          options: ["middle", "center", "second"],
          a: "middle",
          tip: "MIDDLE NAME! Not everyone has one!",
          successtip: "✓ MIDDLE NAME! Common in US, UK, Latin America! Optional in many countries!"
        },
        {
          type: "input",
          q: "Complete: Ms. = Miss or Missus? Answer: ___",
          a: ["both", "Both", "either", "Either", "any", "Any"],
          tip: "Ms. = BOTH! Doesn't specify married or not!",
          successtip: "✓ MS.! Modern standard! Doesn't reveal marital status! Professional preferred worldwide!"
        }
      ]
    },
    
    {
      id: "m6-u15-s2",
      title: "Set 2: Address Information",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "What do you call the building number? ___ number",
          options: ["House", "Street", "Home"],
          a: "House",
          tip: "HOUSE NUMBER or BUILDING NUMBER! 123, 456, etc.!",
          successtip: "✓ HOUSE NUMBER! First part of address! Example: 80 Elm Drive = 80 is house number!"
        },
        {
          type: "order",
          q: "Traduce: Vivo en la calle Principal número 45.",
          words: ["I", "live", "at", "45", "Main", "Street"],
          a: "I live at 45 Main Street",
          tip: "AT for specific addresses! Number + street name!",
          successtip: "✓ ADDRESS! Pattern: Number + Street Name! 45 Main Street, 100 Oak Avenue!"
        },
        {
          type: "input",
          q: "Complete: House number + ___ = street address",
          a: ["street", "Street", "street name", "Street name"],
          tip: "STREET name! Elm Drive, Oak Street, Main Avenue!",
          successtip: "✓ STREET ADDRESS! Complete address: 80 Elm Drive, 456 Oak Street! Universal format!"
        },
        {
          type: "mc",
          q: "In the US, postal code is called ___.",
          options: ["Zip code", "Post code", "Area code"],
          a: "Zip code",
          tip: "ZIP CODE in US! 5 digits: 10001, 90210!",
          successtip: "✓ ZIP CODE! US format! 5 digits! Example: 90210 (Beverly Hills), 10001 (New York)!"
        },
        {
          type: "match",
          q: "Match US term to UK term:",
          pairs: [
            { left: "Zip code", right: "Postcode" },
            { left: "Cell phone", right: "Mobile" },
            { left: "Apartment", right: "Flat" }
          ],
          a: "completed",
          successtip: "✓ US vs UK! Different words, same meaning! Know both for international communication!"
        },
        {
          type: "input",
          q: "Complete: In UK, zip code is called ___.",
          a: ["postcode", "Postcode", "post code", "Post code"],
          tip: "POSTCODE in UK! Letters + numbers: SW1A 1AA!",
          successtip: "✓ POSTCODE! UK format! Mix letters/numbers! Example: SW1A 1AA (Buckingham Palace)!"
        },
        {
          type: "order",
          q: "Traduce: Mi código postal es 03337.",
          words: ["My", "zip", "code", "is", "03337"],
          a: "My zip code is 03337",
          tip: "ZIP CODE in US! Say oh-three-three-three-seven!",
          successtip: "✓ ZIP CODE! Say each digit! 03337 = oh three three three seven OR zero three..."
        },
        {
          type: "mc",
          q: "What does 'state' mean in US addresses?",
          options: ["The region/provincia", "The country", "The city"],
          a: "The region/provincia",
          tip: "STATE = estado/provincia! California, Texas, New York!",
          successtip: "✓ STATE! US has 50 states! CA (California), TX (Texas), NY (New York)! Like provinces!"
        },
        {
          type: "input",
          q: "Complete: City, ___, Zip Code (US address format)",
          a: ["State", "state"],
          tip: "City, STATE, Zip! Portland, OR 97205!",
          successtip: "✓ US FORMAT! City, State Abbreviation, Zip! Los Angeles, CA 90001! Standard!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: I live in the 123 Main Street. ¿Correcto?",
          options: ["Yes, correct", "No, I live at 123 Main Street", "Both work"],
          a: "No, I live at 123 Main Street",
          tip: "No THE! Use AT for specific address!",
          successtip: "✓ AT! Use AT for specific addresses! AT 123 Main Street! IN for cities: IN Chicago!"
        }
      ]
    },

    // ============================================
    // SETS 3-4: PHONE NUMBERS
    // ============================================
    {
      id: "m6-u15-s3",
      title: "Set 3: Phone Numbers",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "In US English, mobile phone is called ___.",
          options: ["Cell phone", "Cellular", "Hand phone"],
          a: "Cell phone",
          tip: "CELL PHONE in US! Short for 'cellular phone'!",
          successtip: "✓ CELL PHONE! US term! UK says 'mobile'! Both mean same thing worldwide!"
        },
        {
          type: "mc",
          q: "How do you say the number 0 in phone numbers?",
          options: ["Zero, oh, or nought", "Only zero", "Only oh"],
          a: "Zero, oh, or nought",
          tip: "THREE ways! Zero, oh, or nought! All correct!",
          successtip: "✓ THREE OPTIONS! Zero (US common), oh (casual), nought (UK formal)! All accepted!"
        },
        {
          type: "order",
          q: "How to say phone number 555-1234? (say it out)",
          words: ["five", "five", "five", "one", "two", "three", "four"],
          a: "five five five one two three four",
          tip: "Say each digit separately! Five five five...!",
          successtip: "✓ DIGIT BY DIGIT! Phone numbers said individually! 555-1234 = five five five, one two three four!"
        },
        {
          type: "input",
          q: "Complete: How do you say 44? ___ four",
          a: ["double", "Double"],
          tip: "DOUBLE four! Two same digits = double!",
          successtip: "✓ DOUBLE! Shortcut for repeated digits! 44 = double four, 77 = double seven!"
        },
        {
          type: "match",
          q: "Match the number pattern to how you say it:",
          pairs: [
            { left: "44", right: "double four" },
            { left: "555", right: "triple five" },
            { left: "22", right: "double two" }
          ],
          a: "completed",
          successtip: "✓ PATTERNS! DOUBLE for 2 same digits, TRIPLE for 3! Makes phone numbers faster!"
        },
        {
          type: "mc",
          q: "How do you say 555?",
          options: ["Five hundred fifty-five", "Triple five", "Five five five"],
          a: "Triple five",
          tip: "TRIPLE five! Three same digits = triple!",
          successtip: "✓ TRIPLE! Quick way! 555 = triple five, 888 = triple eight! Efficient!"
        },
        {
          type: "order",
          q: "Traduce: Mi número de celular es 617-555-5351.",
          words: ["My", "cell", "phone", "number", "is", "617-555-5351"],
          a: "My cell phone number is 617-555-5351",
          tip: "CELL PHONE NUMBER! US term!",
          successtip: "✓ COMPLETE! Say: six one seven, triple five, five three five one! Natural grouping!"
        },
        {
          type: "input",
          q: "Complete: UK: ___ number. US: cell phone number.",
          a: ["mobile", "Mobile", "mobile phone", "Mobile phone"],
          tip: "MOBILE in UK! Short for 'mobile phone'!",
          successtip: "✓ MOBILE! UK standard! Mobile number! US says cell phone! Know both!"
        },
        {
          type: "mc",
          q: "How do you say phone number 07700 900 742? (UK format)",
          options: ["Oh double seven oh oh, nine oh oh, seven four two", "Zero seven seven zero zero, nine hundred, seven forty-two", "Oh seven seven zero zero, nine zero zero, seven four two"],
          a: "Oh double seven oh oh, nine oh oh, seven four two",
          tip: "Use DOUBLE! Group numbers naturally!",
          successtip: "✓ NATURAL GROUPING! UK mobile start with 07! Use double for 77, oh oh for 00!"
        },
        {
          type: "input",
          q: "Complete: What's your phone ___? (número)",
          a: ["number", "Number"],
          tip: "PHONE NUMBER! Essential question!",
          successtip: "✓ PHONE NUMBER! Universal question! Important for contacts, emergencies worldwide!"
        }
      ]
    },

    {
      id: "m6-u15-s4",
      title: "Set 4: More Phone Numbers Practice",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "Which is correct for 1-617-555-5351?",
          options: ["One, six one seven, triple five, five three five one", "One six one seven five five five five three five one", "Both are correct"],
          a: "One, six one seven, triple five, five three five one",
          tip: "Group naturally! Use TRIPLE for 555!",
          successtip: "✓ NATURAL! US phone: country code 1, area code 617, then number! Group logically!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cuál es tu número de teléfono?",
          words: ["What's", "your", "phone", "number"],
          a: "What's your phone number",
          tip: "WHAT'S YOUR = What is your! Essential question!",
          successtip: "✓ KEY QUESTION! Essential for networking, emergencies, friendship worldwide!"
        },
        {
          type: "input",
          q: "Complete: 00 44 = oh oh ___ four (international UK code)",
          a: ["double", "Double"],
          tip: "DOUBLE four! 00 = oh oh, 44 = double four!",
          successtip: "✓ INTERNATIONAL! 00 44 = UK country code! Used when calling UK from abroad!"
        },
        {
          type: "mc",
          q: "How do you say 503-225-3500?",
          options: ["Five oh three, two two five, three five oh oh", "Five oh three, double two five, three five double oh", "Both are correct"],
          a: "Both are correct",
          tip: "Both ways work! DOUBLE optional but common!",
          successtip: "✓ FLEXIBLE! Can use double or say twice! Personal preference! Both understood!"
        },
        {
          type: "match",
          q: "Match the phone format to the country:",
          pairs: [
            { left: "1-617-555-5351", right: "US format" },
            { left: "07700 900 742", right: "UK mobile" },
            { left: "+44 1191 278 594", right: "UK landline" }
          ],
          a: "completed",
          successtip: "✓ FORMATS! Different countries, different patterns! International calls need country code!"
        },
        {
          type: "order",
          q: "Say: 278 with 'double' = two ___ eight",
          words: ["seven", "eight", "double"],
          a: "two double seven eight",
          tip: "278 = two DOUBLE SEVEN eight!",
          successtip: "✓ DOUBLE IN MIDDLE! Can use double anywhere: 278, 334, 665! Makes it faster!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My phone is the 555-1234. ¿Correcto?",
          options: ["Yes, correct", "No, My phone number is 555-1234", "Both work"],
          a: "No, My phone number is 555-1234",
          tip: "Say 'phone NUMBER'! No THE!",
          successtip: "✓ PHONE NUMBER! Complete phrase! No article THE before numbers!"
        },
        {
          type: "input",
          q: "Complete: Can I have your ___ number? (teléfono)",
          a: ["phone", "Phone", "cell phone", "Cell phone", "mobile", "Mobile"],
          tip: "PHONE number! Universal request!",
          successtip: "✓ POLITE REQUEST! Can I have your phone number? Essential for networking!"
        },
        {
          type: "mc",
          q: "Which says 888?",
          options: ["Eight hundred eighty-eight", "Triple eight", "Eight eight eight"],
          a: "Triple eight",
          tip: "TRIPLE eight! Shortest and clearest!",
          successtip: "✓ TRIPLE! Best for three same digits! 888, 777, 000 all use triple!"
        },
        {
          type: "input",
          q: "Complete: +1 = US country code. +44 = ___ country code.",
          a: ["UK", "uk", "United Kingdom", "united kingdom"],
          tip: "UK or United Kingdom! +44 is UK!",
          successtip: "✓ COUNTRY CODES! +1 (US/Canada), +44 (UK), +52 (Mexico), +61 (Australia)! International calls!"
        }
      ]
    },

    // ============================================
    // SETS 5-6: EMAIL ADDRESSES
    // ============================================
    {
      id: "m6-u15-s5",
      title: "Set 5: Email Addresses",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "How do you say @ in email addresses?",
          options: ["Arroba", "At", "A"],
          a: "At",
          tip: "@ = AT! Not 'arroba' in English!",
          successtip: "✓ AT! Universal! name@email.com = 'name at email dot com'! Worldwide standard!"
        },
        {
          type: "mc",
          q: "How do you say . (period) in emails?",
          options: ["Point", "Dot", "Period"],
          a: "Dot",
          tip: "DOT for period in emails/websites! Not point!",
          successtip: "✓ DOT! . = DOT in emails! name.smith@email.com = 'name dot smith at email dot com'!"
        },
        {
          type: "order",
          q: "How to say rob.johnson@webmail.net?",
          words: ["rob", "dot", "johnson", "at", "webmail", "dot", "net"],
          a: "rob dot johnson at webmail dot net",
          tip: "DOT between names, AT for @, DOT before domain!",
          successtip: "✓ EMAIL! Pattern: name DOT name AT domain DOT extension! Universal format!"
        },
        {
          type: "input",
          q: "Complete: How to say _@_? Use word for @.",
          a: ["at", "At"],
          tip: "@ = AT! Central part of email!",
          successtip: "✓ AT! Critical word! Everything before @ = username, after @ = domain!"
        },
        {
          type: "match",
          q: "Match the email symbol to pronunciation:",
          pairs: [
            { left: "@", right: "at" },
            { left: ".", right: "dot" },
            { left: "_", right: "underscore" }
          ],
          a: "completed",
          successtip: "✓ EMAIL SYMBOLS! @ = at, . = dot, _ = underscore! Essential for spelling emails!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My email is maria arroba gmail punto com. ¿Correcto en inglés?",
          options: ["Yes, correct", "No, maria at gmail dot com", "Both work"],
          a: "No, maria at gmail dot com",
          tip: "Use English words! AT not arroba, DOT not punto!",
          successtip: "✓ ENGLISH! maria@gmail.com = 'maria at gmail dot com'! Not Spanish words!"
        },
        {
          type: "order",
          q: "Traduce: Mi email es juan99@hotmail.com",
          words: ["My", "email", "is", "juan99@hotmail.com"],
          a: "My email is juan99@hotmail.com",
          tip: "MY EMAIL IS! Then spell it out!",
          successtip: "✓ COMPLETE! Say: 'My email is juan ninety-nine at hotmail dot com'!"
        },
        {
          type: "input",
          q: "Complete: gill.smith99@domain.com = gill ___ smith ninety-nine ___ domain ___ com",
          a: ["dot, at, dot", "Dot, at, dot", "dot at dot"],
          tip: "DOT, AT, DOT! Three key words!",
          successtip: "✓ PATTERN! gill DOT smith ninety-nine AT domain DOT com! Clear structure!"
        },
        {
          type: "mc",
          q: "How do you say _ (underscore) in emails?",
          options: ["Under bar", "Underscore", "Under line"],
          a: "Underscore",
          tip: "UNDERSCORE! Used in usernames: john_smith!",
          successtip: "✓ UNDERSCORE! Alternative to dot: john_smith or john.smith! Both common!"
        },
        {
          type: "input",
          q: "Complete: What's your ___ address? (correo electrónico)",
          a: ["email", "Email", "e-mail", "E-mail"],
          tip: "EMAIL address! Standard question!",
          successtip: "✓ EMAIL ADDRESS! Essential for communication worldwide! Jobs, friends, services!"
        }
      ]
    },

    {
      id: "m6-u15-s6",
      title: "Set 6: Website Addresses & More",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "How do you say www?",
          options: ["World wide web", "Double-u double-u double-u", "W W W"],
          a: "Double-u double-u double-u",
          tip: "DOUBLE-U three times! Or just say each W!",
          successtip: "✓ WWW! Double-u double-u double-u! Or 'dub dub dub' (casual)! Common to skip now!"
        },
        {
          type: "order",
          q: "How to say www.domain.com?",
          words: ["double-u", "double-u", "double-u", "dot", "domain", "dot", "com"],
          a: "double-u double-u double-u dot domain dot com",
          tip: "THREE double-u, DOT domain DOT com!",
          successtip: "✓ WEBSITE! Pattern: www DOT name DOT extension! .com most common worldwide!"
        },
        {
          type: "input",
          q: "Complete: .com = dot ___",
          a: ["com", "Com", "COM"],
          tip: "DOT COM! Most popular domain extension!",
          successtip: "✓ DOT COM! Commercial websites! .com, .org, .net, .edu most common!"
        },
        {
          type: "mc",
          q: "How do you say .co.uk? (UK website ending)",
          options: ["Dot co dot uk", "Dot co uk", "Dot com uk"],
          a: "Dot co dot uk",
          tip: "DOT co DOT uk! TWO dots!",
          successtip: "✓ UK DOMAIN! .co.uk for UK businesses! .gov.uk for government! Country-specific!"
        },
        {
          type: "match",
          q: "Match the domain ending to meaning:",
          pairs: [
            { left: ".com", right: "commercial" },
            { left: ".org", right: "organization" },
            { left: ".edu", right: "education" }
          ],
          a: "completed",
          successtip: "✓ DOMAINS! .com (business), .org (non-profit), .edu (schools)! Types of websites!"
        },
        {
          type: "order",
          q: "Say website: mycompany.co.uk",
          words: ["mycompany", "dot", "co", "dot", "uk"],
          a: "mycompany dot co dot uk",
          tip: "DOT co DOT uk! UK business format!",
          successtip: "✓ UK BUSINESS! .co.uk common! Australia .com.au, Mexico .com.mx! Country codes!"
        },
        {
          type: "mc",
          q: "Modern trend: www often ___.",
          options: ["Required", "Optional", "Incorrect"],
          a: "Optional",
          tip: "WWW often OPTIONAL now! Many skip it!",
          successtip: "✓ OPTIONAL! Modern websites work without www! google.com = www.google.com!"
        },
        {
          type: "input",
          q: "Complete: info@company.com = info ___ company dot com",
          a: ["at", "At"],
          tip: "AT for @! Same in emails!",
          successtip: "✓ AT! Business emails! info@, contact@, support@ common formats!"
        },
        {
          type: "order",
          q: "Traduce: Mi sitio web es www.miempresa.com",
          words: ["My", "website", "is", "www.miempresa.com"],
          a: "My website is www.miempresa.com",
          tip: "MY WEBSITE IS! Then spell URL!",
          successtip: "✓ WEBSITE! Say: 'double-u double-u double-u dot miempresa dot com'!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My website is www punto domain punto com. ¿Correcto en inglés?",
          options: ["Yes, correct", "No, www dot domain dot com", "Both work"],
          a: "No, www dot domain dot com",
          tip: "Use DOT not punto! English only!",
          successtip: "✓ DOT! Not punto! English pronunciation for international communication!"
        }
      ]
    },

    // ============================================
    // SETS 7-8: SPELLING OUT LOUD
    // ============================================
    {
      id: "m6-u15-s7",
      title: "Set 7: Spelling Names",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "When someone asks 'How do you spell that?', you should ___.",
          options: ["Write it", "Say each letter", "Repeat the word"],
          a: "Say each letter",
          tip: "Say each LETTER! Spell it out loud!",
          successtip: "✓ SPELLING! Say letters one by one! M-A-R-I-A! Essential for names, addresses!"
        },
        {
          type: "order",
          q: "How to spell GARCIA?",
          words: ["G", "A", "R", "C", "I", "A"],
          a: "G A R C I A",
          tip: "Each letter separately! G-A-R-C-I-A!",
          successtip: "✓ SPELLING! Each letter clear! Important for forms, reservations, introductions!"
        },
        {
          type: "input",
          q: "Complete: How do you ___ your name? (deletrear)",
          a: ["spell", "Spell"],
          tip: "SPELL your name! Deletrear = spell!",
          successtip: "✓ SPELL! 'How do you spell...?' Universal question! Names, streets, cities!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: Spanish speakers often confuse which letters?",
          options: ["B and V", "E and I", "Both of these"],
          a: "Both of these",
          tip: "Both confusing! B/V sound same in Spanish, E/I pronunciation different!",
          successtip: "✓ CAREFUL! B = 'bee', V = 'vee'! E = 'ee', I = 'eye' (ai)! Practice these!"
        },
        {
          type: "match",
          q: "Match confusing letters to pronunciation:",
          pairs: [
            { left: "E", right: "ee (like español)" },
            { left: "I", right: "ai (like ojo)" },
            { left: "A", right: "ei (like hey)" }
          ],
          a: "completed",
          successtip: "✓ VOWELS! E='ee', I='ai', A='ei'! Different from Spanish! Practice pronunciation!"
        },
        {
          type: "order",
          q: "Spell: MARIA = M-A-R-I-A. How to say I?",
          words: ["I", "sounds", "like", "eye"],
          a: "I sounds like eye",
          tip: "I = 'eye' (ai)! Not 'ee'!",
          successtip: "✓ LETTER I! Sounds like 'eye' or 'ai'! M-A-R-'ai'-A! Common mistake!"
        },
        {
          type: "mc",
          q: "Which is correct pronunciation of letter A?",
          options: ["ah (like Spanish)", "ei (like 'hey')", "ee (like 'see')"],
          a: "ei (like 'hey')",
          tip: "A = 'ei' (like HEY)! Not 'ah'!",
          successtip: "✓ LETTER A! Sounds like 'ei' in English! Different from Spanish 'ah'!"
        },
        {
          type: "input",
          q: "Complete: Could you ___ that, please? (spell again)",
          a: ["spell", "Spell", "repeat", "Repeat"],
          tip: "SPELL or REPEAT! Polite request!",
          successtip: "✓ POLITE! 'Could you spell that?' or 'Could you repeat that?' Both professional!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cómo se deletrea tu apellido?",
          words: ["How", "do", "you", "spell", "your", "last", "name"],
          a: "How do you spell your last name",
          tip: "HOW DO YOU SPELL! Standard question!",
          successtip: "✓ ESSENTIAL QUESTION! Last names difficult! Always ask for spelling!"
        },
        {
          type: "mc",
          q: "Spelling tip: For clarity, you can say ___.",
          options: ["Just the letter", "Letter + example word", "Write it only"],
          a: "Letter + example word",
          tip: "PHONETIC! 'M as in Maria', 'S as in Sam'!",
          successtip: "✓ PHONETIC ALPHABET! M for Maria, S for Sam, B for Boy! Prevents confusion!"
        }
      ]
    },

    {
      id: "m6-u15-s8",
      title: "Set 8: Spelling Cities & Places",
      category: "vocabulary",
      exercises: [
        {
          type: "mc",
          q: "How do you ask someone to spell a city name?",
          options: ["How you spell?", "How do you spell that?", "How is spelled?"],
          a: "How do you spell that?",
          tip: "HOW DO YOU SPELL THAT? Complete question!",
          successtip: "✓ CORRECT GRAMMAR! 'How do you spell that?' Not 'How you spell?' Need DO!"
        },
        {
          type: "order",
          q: "Spell CHICAGO: C-H-I-C-A-G-O. Say the letters.",
          words: ["C", "H", "I", "C", "A", "G", "O"],
          a: "C H I C A G O",
          tip: "Seven letters! C-H-I-C-A-G-O!",
          successtip: "✓ CHICAGO! Major US city! Spelling important for tickets, reservations!"
        },
        {
          type: "input",
          q: "Complete: Can you ___ that for me? (spell)",
          a: ["spell", "Spell"],
          tip: "SPELL that! Polite request!",
          successtip: "✓ POLITE REQUEST! 'Can you spell that for me?' Professional and friendly!"
        },
        {
          type: "mc",
          q: "Spell BEIJING: B-E-I-J-I-N-G. The J sounds like ___.",
          options: ["H (Spanish jota)", "J (English jay)", "Y (Spanish ye)"],
          a: "J (English jay)",
          tip: "J in English = 'jay' sound! Not Spanish 'jota'!",
          successtip: "✓ LETTER J! English J = 'jay' (like 'jay-walking')! Not Spanish 'jota' sound!"
        },
        {
          type: "match",
          q: "Match the place to correct spelling:",
          pairs: [
            { left: "Madagascar", right: "M-A-D-A-G-A-S-C-A-R" },
            { left: "Illinois", right: "I-L-L-I-N-O-I-S" },
            { left: "Massachusetts", right: "M-A-S-S-A-C-H-U-S-E-T-T-S" }
          ],
          a: "completed",
          successtip: "✓ DIFFICULT SPELLINGS! Double letters common! Practice hard names!"
        },
        {
          type: "order",
          q: "Spell MEXICO: M-E-X-I-C-O. Say each letter.",
          words: ["M", "E", "X", "I", "C", "O"],
          a: "M E X I C O",
          tip: "Six letters! M-E-X-I-C-O!",
          successtip: "✓ MEXICO! Remember X in English = 'eks' not Spanish 'equis'!"
        },
        {
          type: "mc",
          q: "Double letters: ILLINOIS has double ___.",
          options: ["L", "I", "Both L and I"],
          a: "Both L and I",
          tip: "DOUBLE L and DOUBLE I! I-L-L-I-N-O-I-S!",
          successtip: "✓ DOUBLE LETTERS! Illinois = I-double-L-I-N-O-I-S! Can say 'double L'!"
        },
        {
          type: "input",
          q: "Complete: Sorry, I didn't ___ that. Can you spell it? (catch)",
          a: ["catch", "Catch", "get", "Get", "hear", "Hear"],
          tip: "CATCH, GET, or HEAR! All work!",
          successtip: "✓ POLITE! 'I didn't catch that' = professional! Shows you're listening!"
        },
        {
          type: "order",
          q: "Traduce: ¿Puedes deletrear el nombre de tu ciudad?",
          words: ["Can", "you", "spell", "your", "city", "name"],
          a: "Can you spell your city name",
          tip: "CAN YOU SPELL! Polite request!",
          successtip: "✓ CITIES! Important for travel bookings, addresses, mail!"
        },
        {
          type: "mc",
          q: "Phonetic alphabet example: B as in ___.",
          options: ["Boy", "Be", "Bee"],
          a: "Boy",
          tip: "B as in BOY! Example word for clarity!",
          successtip: "✓ PHONETIC! B for Boy, M for Mary, S for Sam! Prevents B/V confusion!"
        }
      ]
    },

    // ============================================
    // SETS 9-10: COMPLETE CONTACT INFO & INTEGRATION
    // ============================================
    {
      id: "m6-u15-s9",
      title: "Set 9: Complete Contact Information",
      category: "integration",
      exercises: [
        {
          type: "mc",
          q: "Complete contact info needs: name, address, phone, and ___.",
          options: ["Email", "Job", "Age"],
          a: "Email",
          tip: "NAME, ADDRESS, PHONE, EMAIL! Four essentials!",
          successtip: "✓ FOUR ESSENTIALS! Name, address, phone, email! Standard worldwide for forms!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cuál es tu información de contacto?",
          words: ["What's", "your", "contact", "information"],
          a: "What's your contact information",
          tip: "CONTACT INFORMATION! Complete details!",
          successtip: "✓ CONTACT INFO! Name, phone, email, address! Essential for networking!"
        },
        {
          type: "input",
          q: "Complete: My full name is ___. (your name or 'Juan Carlos López')",
          a: ["any name accepted"],
          tip: "FULL NAME! First + middle + last!",
          successtip: "✓ INTRODUCTION! Start with full name! Professional standard!"
        },
        {
          type: "mc",
          q: "Business card typically includes:",
          options: ["Only email", "Name, title, phone, email, address", "Only phone"],
          a: "Name, title, phone, email, address",
          tip: "COMPLETE INFO! All contact methods!",
          successtip: "✓ BUSINESS CARD! Professional networking tool! Include all ways to contact!"
        },
        {
          type: "match",
          q: "Match the situation to what info you need:",
          pairs: [
            { left: "Job application", right: "Full contact details" },
            { left: "Making friends", right: "Phone and social media" },
            { left: "Emergency contact", right: "Name and phone number" }
          ],
          a: "completed",
          successtip: "✓ CONTEXT! Different situations need different info! Professional vs casual!"
        },
        {
          type: "order",
          q: "Say complete: My name is ___, my email is ___, and my phone is ___.",
          words: ["My", "name", "is", "my", "email", "is", "and", "my", "phone", "is"],
          a: "My name is my email is and my phone is",
          tip: "THREE KEY PIECES! Name, email, phone!",
          successtip: "✓ COMPLETE! Practice saying all three together! Common introduction!"
        },
        {
          type: "mc",
          q: "When filling forms online, ___ marked with * are required.",
          options: ["All fields", "Fields", "None"],
          a: "Fields",
          tip: "ASTERISK * = REQUIRED! Must complete!",
          successtip: "✓ REQUIRED FIELDS! * means mandatory! Name, email usually required!"
        },
        {
          type: "input",
          q: "Complete: Can I get your ___ details? (contact)",
          a: ["contact", "Contact"],
          tip: "CONTACT DETAILS! Professional request!",
          successtip: "✓ NETWORKING! 'Can I get your contact details?' Professional way to exchange info!"
        },
        {
          type: "order",
          q: "Traduce: Déjame darte mi información.",
          words: ["Let", "me", "give", "you", "my", "information"],
          a: "Let me give you my information",
          tip: "LET ME GIVE YOU! Offering information!",
          successtip: "✓ OFFERING! Polite way to share contact info! 'Let me give you my details'!"
        },
        {
          type: "mc",
          q: "ERROR COMÚN: My information is the following. Better: ___",
          options: ["Here is my information", "My information are", "The information is me"],
          a: "Here is my information",
          tip: "HERE IS! More natural than 'the following'!",
          successtip: "✓ NATURAL! 'Here is my information' or 'Here are my details'! Common phrasing!"
        }
      ]
    },

    {
      id: "m6-u15-s10",
      title: "Set 10: US vs UK & Final Integration",
      category: "integration",
      exercises: [
        {
          type: "match",
          q: "Match US term to UK equivalent:",
          pairs: [
            { left: "Cell phone", right: "Mobile" },
            { left: "Zip code", right: "Postcode" },
            { left: "Apartment", right: "Flat" }
          ],
          a: "completed",
          tip: "Review US vs UK differences!",
          successtip: "✓ US vs UK! Same meaning, different words! Know both for international travel!"
        },
        {
          type: "mc",
          q: "Which format: 90210?",
          options: ["US zip code", "UK postcode", "Phone number"],
          a: "US zip code",
          tip: "5 digits = US ZIP CODE! Famous Beverly Hills code!",
          successtip: "✓ ZIP CODE! 90210 = Beverly Hills! US format 5 digits! UK mixes letters/numbers!"
        },
        {
          type: "order",
          q: "Complete address format: Name, Street, City, ___, Zip, Country",
          words: ["State"],
          a: "State",
          tip: "US format includes STATE! Between city and zip!",
          successtip: "✓ US FORMAT! Name, Street, City, State, Zip, Country! Complete address!"
        },
        {
          type: "input",
          q: "Complete: UK postcode example: SW1A ___",
          a: ["1AA", "1aa"],
          tip: "UK POSTCODE! Letters + numbers! SW1A 1AA!",
          successtip: "✓ UK POSTCODE! SW1A 1AA = Buckingham Palace! Mix of letters and numbers!"
        },
        {
          type: "mc",
          q: "International format phone: +1 = USA. +44 = ___",
          options: ["UK", "Canada", "Australia"],
          a: "UK",
          tip: "+44 = UNITED KINGDOM! Country calling code!",
          successtip: "✓ COUNTRY CODES! +1 (US/Canada), +44 (UK), +52 (Mexico), +61 (Australia)!"
        },
        {
          type: "order",
          q: "Traduce: ¿Cuál es tu dirección completa?",
          words: ["What's", "your", "full", "address"],
          a: "What's your full address",
          tip: "FULL ADDRESS! Complete information!",
          successtip: "✓ FULL ADDRESS! Street, city, state/province, postal code, country! Complete!"
        },
        {
          type: "mc",
          q: "On international forms, ___ is the two-letter country code.",
          options: ["City code", "ISO code", "Zip code"],
          a: "ISO code",
          tip: "ISO CODE! US, UK, MX, CA, etc.!",
          successtip: "✓ ISO CODES! US (United States), UK (United Kingdom), MX (Mexico)! Standard!"
        },
        {
          type: "input",
          q: "Complete: I live ___ 123 Main Street ___ Chicago. (prepositions)",
          a: ["at, in", "At, in", "at in"],
          tip: "AT for specific address, IN for city!",
          successtip: "✓ PREPOSITIONS! AT + address, IN + city! I live AT 123 Main IN Chicago!"
        },
        {
          type: "order",
          q: "Professional intro: Hi, I'm ___, here's my card.",
          words: ["Hi", "I'm", "here's", "my", "card"],
          a: "Hi I'm here's my card",
          tip: "BUSINESS CARD! Professional networking!",
          successtip: "✓ NETWORKING! Exchange business cards! Name + handshake + card! Universal!"
        },
        {
          type: "mc",
          q: "CELEBRATION! You can now exchange complete contact information! What's most important?",
          options: ["Being clear and accurate", "Speaking fast", "Using difficult words"],
          a: "Being clear and accurate",
          tip: "CLARITY! Speak clearly when giving contact info!",
          successtip: "✓ UNIT COMPLETE! 🎉📇 You mastered contact information! You can spell names, say phone numbers, email addresses, websites, and complete forms! You know US vs UK differences! Ready for real-world networking! ¡Excelente trabajo!"
        }
      ]
    }
  ],

  // ============================================
  // READING SET (REDUCIDO)
  // ============================================
  readingSet: {
    id: "m6-u15-reading",
    title: "Set 11: Reading Practice - Business Card",
    category: "reading",
    passage: `BUSINESS CARD

Jonathan William Smith
Marketing Director

Company: Digital Solutions Inc.
Address: 2629 Gateway Street
         Portland, OR 97205
         United States

Phone: +1 503-225-3500
Mobile: +1 617-555-0142
Email: jonny.smith@digitalsolutions.com
Website: www.digitalsolutions.com

"Contact me anytime for digital marketing solutions!"`,
    questions: [
      {
        type: "input",
        q: "What is his first name?",
        a: ["Jonathan", "jonathan"],
        tip: "First name before middle and last!"
      },
      {
        type: "mc",
        q: "What is his middle name?",
        options: ["Jonathan", "William", "Smith"],
        a: "William",
        tip: "Between first and last name!"
      },
      {
        type: "input",
        q: "What is his last name?",
        a: ["Smith", "smith"],
        tip: "Family name at the end!"
      },
      {
        type: "mc",
        q: "What is his job title?",
        options: ["Marketing Director", "Manager", "CEO"],
        a: "Marketing Director",
        tip: "Title listed under name!"
      },
      {
        type: "input",
        q: "What is his house number?",
        a: ["2629"],
        tip: "First number in address!"
      },
      {
        type: "mc",
        q: "What city does he live in?",
        options: ["Portland", "Oregon", "Gateway"],
        a: "Portland",
        tip: "City name before state!"
      },
      {
        type: "input",
        q: "What is the zip code?",
        a: ["97205"],
        tip: "5-digit US postal code!"
      },
      {
        type: "mc",
        q: "How do you say his email?",
        options: ["jonny dot smith at digitalsolutions dot com", "jonny smith digitalsolutions com", "jonny arroba digitalsolutions punto com"],
        a: "jonny dot smith at digitalsolutions dot com",
        tip: "Use DOT and AT in English!"
      },
      {
        type: "input",
        q: "What is the area code of his office phone?",
        a: ["503"],
        tip: "First three digits after +1!"
      },
      {
        type: "mc",
        q: "What's the company website domain?",
        options: [".com", ".org", ".co.uk"],
        a: ".com",
        tip: "Look at the website ending!"
      }
    ]
  },

  // ============================================
  // REVIEW SET
  // ============================================
  reviewSet: {
    id: "m6-u15-review",
    title: "Set 12: Review - Contact Information",
    category: "review",
    exercises: [
      {
        type: "mc",
        q: "How do you say @ in English?",
        options: ["Arroba", "At", "A"],
        a: "At",
        tip: "@ = AT! Not Spanish 'arroba'!",
        successtip: "✓ AT! Universal in emails! name@email.com!"
      },
      {
        type: "order",
        q: "ERROR: My email is maria arroba gmail punto com. CORRECT IT:",
        words: ["maria", "at", "gmail", "dot", "com"],
        a: "maria at gmail dot com",
        tip: "Use English! AT and DOT!",
        successtip: "✓ ENGLISH TERMS! AT for @, DOT for period! Essential for international communication!"
      },
      {
        type: "mc",
        q: "How do you say 555?",
        options: ["Five five five", "Triple five", "Both are correct"],
        a: "Both are correct",
        tip: "Both ways work! TRIPLE is shorter!",
        successtip: "✓ BOTH! Triple five faster! Five five five also correct! Personal choice!"
      },
      {
        type: "input",
        q: "Complete: US = cell phone. UK = ___",
        a: ["mobile", "Mobile", "mobile phone", "Mobile phone"],
        tip: "MOBILE in UK! Same device, different name!",
        successtip: "✓ UK TERM! Mobile! Also: flat (apartment), postcode (zip code), lift (elevator)!"
      },
      {
        type: "match",
        q: "Match the error to correction:",
        pairs: [
          { left: "My name is the Maria", right: "My name is Maria" },
          { left: "I live in the 123 Main St", right: "I live at 123 Main St" },
          { left: "The three o'clock", right: "Three o'clock" }
        ],
        a: "completed",
        tip: "Review common THE errors!",
        successtip: "✓ NO THE! Major error for Spanish speakers! No THE before names, addresses, times!"
      },
      {
        type: "mc",
        q: "How do you spell your name? Means: ___",
        options: ["Write it", "Say each letter", "Repeat it"],
        a: "Say each letter",
        tip: "SPELL = say letters! M-A-R-I-A!",
        successtip: "✓ SPELLING! Letter by letter! Essential skill for forms, introductions!"
      },
      {
        type: "order",
        q: "Traduce: ¿Cuál es tu número de teléfono?",
        words: ["What's", "your", "phone", "number"],
        a: "What's your phone number",
        tip: "WHAT'S YOUR! Essential question!",
        successtip: "✓ KEY QUESTION! With name and email, makes complete contact info!"
      },
      {
        type: "input",
        q: "Complete: 03/10/2024 in US = ___ 10, 2024 (month name)",
        a: ["March", "march"],
        tip: "US MONTH FIRST! 03 = March!",
        successtip: "✓ US FORMAT! Month/Day/Year! Different from most countries! Know both!"
      },
      {
        type: "mc",
        q: "Professional intro: Hi, I'm John Smith. Here's my ___.",
        options: ["Information", "Card", "Email"],
        a: "Card",
        tip: "BUSINESS CARD! Professional networking!",
        successtip: "✓ BUSINESS CARD! Exchange cards when networking! Name, title, contact info!"
      },
      {
        type: "order",
        q: "CELEBRATION! You completed Module 6! Say: I can communicate in English confidently now!",
        words: ["I", "can", "communicate", "in", "English", "confidently", "now"],
        a: "I can communicate in English confidently now",
        tip: "You learned 3 units: countries/locations, numbers/times/dates, and contact info!",
        successtip: "✓ MODULE 6 COMPLETE! 🎉🌍📞 You mastered geographic locations, statistics, times, dates, AND contact information! You can introduce yourself, give your address, phone, email, spell names, and understand international formats! You're ready for real-world English communication worldwide! ¡EXCELENTE TRABAJO! You completed all units! 🎊"
      }
    ]
  }
};
